// extracted by mini-css-extract-plugin
export default {"historyFooter":"HistoryFooter_historyFooter__C3oJ8","menuList":"HistoryFooter_menuList__iGyUG","menuFooter":"HistoryFooter_menuFooter__jahxM"};